<span *ngIf="item['can_publish']">
  <em
    *ngIf="!neverPublished(item?.dates) && needsPublish(item?.dates)"
    class="global-item-side icon-upload-to-cloud1"
    title="Last updated: {{ item.dates.changed | amTimeAgo: true }}"
  >
  </em>
  <em *ngIf="neverPublished(item?.dates)" class="global-item-side icon-upload-to-cloud1" title="Never published"> </em>
</span>
